import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { register } from "../store/actions/authActions";

const Register = () => {
  const dispatch = useDispatch();

  const [successful, setSuccessful] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    password: "",
    password1: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .test(
        "len",
        "The username must be between 3 and 20 characters.",
        (val) =>
          val && val.toString().length >= 3 && val.toString().length <= 20
      )
      .required("This field is required!"),
    email: Yup.string()
      .email("This is not a valid email.")
      .required("This field is required!"),
    password: Yup.string()
      .test(
        "len",
        "The password must be between 6 and 40 characters.",
        (val) =>
          val && val.toString().length >= 6 && val.toString().length <= 40
      )
      .required("This field is required!"),
  });

  const handleRegister = (formValue) => {
    const { name, email, password, password1 } = formValue;

    setSuccessful(false);
    console.log("I am here");
    dispatch(register({ name, email, password, password1 }))
      .then(() => {
        setSuccessful(true);
        console.log("successful", successful);
      })
      .catch(() => {
        setSuccessful(false);
      });
  };

  if (successful) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="md:w-full max-w-[350px] m-auto pt-28">
      <div className="bg-f7f7f7 p-[20px] px-[25px] py-[30px] mx-auto mb-[25px] mt-[50px] rounded-md shadow-md">
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="w-[96px] h-[96px] mx-auto mb-[10px] rounded-full"
        />
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleRegister}
        >
          <Form>
            {!successful && (
              <div>
                <div className="mb-10">
                  <label htmlFor="name">Username</label>
                  <Field name="name" type="text" className="form-control" />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>

                <div className="mb-10">
                  <label htmlFor="email">Email</label>
                  <Field name="email" type="email" className="form-control" />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>

                <div className="mb-10">
                  <label htmlFor="password">Password</label>
                  <Field
                    name="password"
                    type="password"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>
                <div className="mb-10">
                  <label htmlFor="password1">Confirm password</label>
                  <Field
                    name="password1"
                    type="password"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="password1"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>

                <div className="mb-10 text-center">
                  <button type="submit" className="btn btn-primary btn-block">
                    Sign Up
                  </button>
                </div>
              </div>
            )}
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default Register;
